import { ANALYTICS_MODULE_CARDS_DETIALS } from "../actions/analyticsActions";

const initialState = {
    card_details: [],
};

const analyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ANALYTICS_MODULE_CARDS_DETIALS:
            return {
                ...state,
                card_details: action.payload,
            };
        default:
            return state;
    }
};

export default analyticsReducer;
